import React from 'react';

const jQuery_HTML = () => {
  return (
    <div >
      <h1>jQuery_HTML</h1>
      <p>Placeholder component for: "jQuery HTML"</p>
    </div>
  );
};

export default jQuery_HTML;
